import { useParams } from "react-router-dom";
import ServicesContent from "../content/ServicesContent";

export default function FromServices() {
    const { slug } = useParams();

    return <ServicesContent currentPage={slug || "home"} />;
}